import {
    convertUniversalDateToPersianDate, DialogSize,
    RaikoBaseCardContainer, RaikoBaseDialogContentContainer,
    RaikoButtonSecondary,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneItemGenerator, RaikoConfirmDialog, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoGridTwoColumn, RaikoSectionContainer,
    RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {useDebounce} from "@uidotdev/usehooks";
import ThumborHelper from "../../util/ThumborHelper";
import thumbnailLoad from "../../assets/images/placeholder/Group 1000003894 1.svg";
import {css} from "@emotion/css";
import {GameTeamMemberService} from "../../serverService/gameService/GameTeamMemberService";
import {RouteHelper} from "../../route/RouteHelper";
import {GameTeamStatusType} from "../gameTeams/GameTeamStatusType";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import PlayerSelection from "../playerSelection/PlayerSelection";

export default function GameTeamMembers({gameTeamId}) {

    let page = 0;
    const size = 20;

    const [selectDisplayType, setSelectDisplayType] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [numberOfItems, setNumberOfItems] = useState(0);

    const [displayName, setDisplayName] = useState("");
    const _displayNameFilter = useDebounce(displayName, 500);

    const [gameTeamMembersData, setGameTeamMembersData] = useState([]);

    const service = new GameTeamMemberService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameTeamMembersListFromServer()
        }
    }, [_displayNameFilter]);


    function handleChangePage(newPage) {
        page = newPage
        getGameTeamMembersListFromServer()
    }

    function gameTeamMembersTablePreparation(
        id,
        number,
        thumbnail,
        displayName,
        participantId,
        role,
        jointedAt
    ) {
        return {
            id,
            number,
            thumbnail: thumbnail ? <img
                    src={new
                    ThumborHelper.Builder(thumbnail)
                        .setImageCompressSize(50, 50)
                        .changeQuality(10)
                        .convertWebp()
                        .build()
                    }
                    className={css`
                        width: 50px;
                        height: 50px;
                        aspect-ratio: 1/1;
                        border-radius: 8px;
                        background: var(--header-border-bottom-color)`
                    }
                    alt=""/>
                : <img
                    src={thumbnail}
                    className={css`
                        border-radius: 8px;
                        width: 50px;
                        height: 50px;
                        aspect-ratio: 1/1;
                        object-fit: cover;
                    `
                    }
                    alt=""/>,
            displayName,
            participantId,
            role,
            jointedAt: convertUniversalDateToPersianDate(jointedAt),
            thumbnailPlace: thumbnail,
        }
    }

    function getGameTeamMembersListFromServer() {
        setTableLoading(true)
        service.getaGameTeamMembersList(gameTeamId, page, size, _displayNameFilter)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setGameTeamMembersData([])
                response.data.map((item, index) => {
                    setGameTeamMembersData(prevState => [
                        ...prevState,
                        gameTeamMembersTablePreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.participant && item.participant.avatar && item.participant.avatar.downloadUrl ? item.participant.avatar.downloadUrl : thumbnailLoad,
                            item.participant && item.participant.displayName ? item.participant.displayName : "",
                            item.participant.id,
                            item.role && item.role === "LEADER" ? "کاپیتان" : "عضو",
                            item.jointedAt,
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })
    }


    const [updateRoleButtonLoading, setUpdateRoleButtonLoading] = useState(false)
    const [gameRole, setGameRole] = useState("MEMBER")

    const [gamerId, setGamerId] = useState(-1)
    const [openUpdateGamerRoleDialog, setOpenUpdateGamerRoleDialog] = useState(false)

    function handleCloseUpdateGamerRoleDialog() {
        setOpenUpdateGamerRoleDialog(false)
    }

    function handleOpenUpdateGamerRoleDialog(teamMemberId) {
        setGamerId(teamMemberId)
        setOpenUpdateGamerRoleDialog(true)
    }

    function handleUpdateGamerRole() {
        setUpdateRoleButtonLoading(true)
        service.updateGamerRole(gamerId, gameRole)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                getGameTeamMembersListFromServer()
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setUpdateRoleButtonLoading(false)
            handleCloseUpdateGamerRoleDialog()
        })
    }

    const [deleteDialogState, setDeleteDialogState] = useState(false);

    function handleOpenDeleteDialog(teamMemberId) {
        setGamerId(teamMemberId)
        setDeleteDialogState(true)
    }

    function handleCloseDeleteDialog() {
        setDeleteDialogState(false)
    }

    function handleDeleteGamer(gamerId) {
        loading.show()
        service.deleteGamer(gamerId)
            .then(response => {
                showSuccessMessage("حذف بازیکن با موفقیت انجام شد.")
                handleCloseDeleteDialog()
                getGameTeamMembersListFromServer()
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })

    }

    const [playerSelectionDialog, setPlayerSelectionDialog] = useState(false)

    function handleOpenPlayerSelectionDialog() {
        setPlayerSelectionDialog(true)
    }

    function handleClosePlayerSelectionDialog() {
        setPlayerSelectionDialog(false)
        getGameTeamMembersListFromServer()
    }


    return (
        <>
            <RaikoDefaultDialogPage
                pageTitle={""}
                hasCloseButton={false}
                dialogSize={DialogSize.WRAP_CONTENT}
                onClose={handleCloseUpdateGamerRoleDialog}
                open={openUpdateGamerRoleDialog}>
                <RaikoBaseDialogContentContainer>
                    <RaikoSectionContainer
                        title={"نقش عضو"}
                        hasActionButton
                        actionButtonLoadingState={updateRoleButtonLoading}
                        actionButtonOnclick={handleUpdateGamerRole}
                    >
                        <RaikoCustomSelect
                            labelText={"وضعیت"}
                            value={gameRole}
                            setValue={setGameRole}
                            items={[
                                raikoCustomSelectItemGenerator("LEADER", "کاپیتان"),
                                raikoCustomSelectItemGenerator("MEMBER", "عضو"),
                            ]}

                        />
                    </RaikoSectionContainer>
                </RaikoBaseDialogContentContainer>
            </RaikoDefaultDialogPage>
            <RaikoDefaultDialogPage
                pageTitle={""}
                dialogSize={DialogSize.LARGE}
                onClose={handleClosePlayerSelectionDialog}
                open={playerSelectionDialog}>
                <PlayerSelection gameTeamId={gameTeamId} handleClosePlayerSelectionDialog={handleClosePlayerSelectionDialog}/>
            </RaikoDefaultDialogPage>


            <RaikoConfirmDialog
                openConfirmDialog={deleteDialogState}
                cancelAction={_ => {
                    setDeleteDialogState(false)
                }}
                doAction={handleDeleteGamer}
                warningDescription={""}
                pageTitle={"حذف بازیکن"}
            />
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoTableTitleContainer
                        title={"بازیکنان تیم"}
                        amount={numberOfItems}
                        hasSelectDisplayType
                        selectDisplayType={selectDisplayType}
                        setSelectDisplayType={setSelectDisplayType}
                        hasCreateNewItem
                        handleCreateNewItem={handleOpenPlayerSelectionDialog}
                    />
                    <RaikoTableSearchContainer
                        labelText={"نام کاربری"}
                        value={displayName}
                        setValue={setDisplayName}
                    />
                    <RaikoCustomTable
                        header={gameTeamMembersListHeader}
                        data={gameTeamMembersData}
                        isLoading={tableLoading}
                        pageCount={pageCount}
                        selectDisplayType={selectDisplayType}
                        handlePaginationChange={handleChangePage}
                    >
                        <RaikoGridTwoColumn className={css`padding: 3px`}>
                            {
                                gameTeamMembersData.map((item, index) => {
                                    return <RaikoCardInfoTypeOne
                                        key={index}
                                        hasAvatar
                                        avatarSource={item.thumbnailPlace}
                                        title={item.displayName}
                                        titleLabel={item.role}
                                        items={[
                                            RaikoCardInfoTypeOneItemGenerator("تاریخ پیوستن", item.jointedAt),
                                        ]}
                                        hasBottomChildren
                                    >
                                        <div className={css`
                                            width: 100%;
                                            display: flex;
                                            gap: 1rem;
                                            align-items: center;
                                            justify-content: end`}>
                                            <RaikoButtonSecondary
                                                label={"اطلاعات کاربر"}
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    event.preventDefault()
                                                    window.open(RouteHelper.UserInformation.globalUrl.replace(":id", item.participantId) + `?title=${encodeURIComponent(item.participantId)}`, "_blank")
                                                }}
                                            />
                                            <RaikoButtonSecondary
                                                label={"تغییر نقش"}
                                                onClick={() => {
                                                    handleOpenUpdateGamerRoleDialog(item.id)
                                                }}
                                            />
                                            <RaikoButtonSecondary
                                                label={"حذف بازیکن"}
                                                onClick={() => {
                                                    handleOpenDeleteDialog(item.id)
                                                }}
                                            />

                                        </div>

                                    </RaikoCardInfoTypeOne>
                                })
                            }
                        </RaikoGridTwoColumn>

                    </RaikoCustomTable>
                </RaikoGridOneColumn>

            </RaikoBaseCardContainer>
        </>

    )
}

const gameTeamMembersListHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "thumbnail",
        label: "تصویر شاخص"
    },
    {
        id: "displayName",
        label: "نام کاربری"
    },
    {
        id: "role",
        label: "نقش عضو در تیم"
    },
    {
        id: "jointedAt",
        label: "تاریخ پیوستن"
    },
]